import Default from "../views/dashboards/Default.vue";
import SigninIllustration from "../views/auth/signin/Illustration.vue";
import ResetIllustration from "../views/auth/reset/Illustration.vue";
import RestorePassword from "../views/auth/reset/RestorePassword.vue";
import ChangePasswordSended from "../views/auth/reset/ChangePasswordSended.vue";
import Vehicles from "../views/vehicles/Vehicles.vue";
import Routes from "../views/routes/Routes.vue";
import Stops from "../views/stops/Stops.vue";
import Bultos from "../views/bultos/Bultos.vue";
import Evidence from "../views/evidence/Evidence.vue";
import Decas from "../views/decas/Decas.vue";
import Zones from "../views/zones/Zones.vue";
import Warehouses from "../views/warehouses/Warehouses.vue";
import Events from "../views/events/Events.vue";
import Plans from "../views/plans/Plans.vue";
import Profile from "../views/profile/Profile.vue";
import UsersPortal from "../views/users/UserPortal.vue";
import UsersVehicle from "../views/users/UserVehicle.vue";
import PlanKanban from "../views/plans/PlanKanban.vue";
import PlanLive from "../views/plans/PlanLive.vue";
import LiveAnalytics from "../views/plans/LiveAnalytics.vue";
import Developer from "../views/developer/Developer.vue";
import DocuInfo from "../views/developer/components/DocuInfo.vue";
import SecurityKey from "../views/security/Security.vue";
export const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/dashboard-default",
  },
  {
    path: "/dashboard-default",
    name: "Dashboard",
    component: Default,
    meta: { breadcrumb: "Dashboard" },
  },
  {
    path: "/plan",
    name: "Planes",
    component: Plans,
    meta: { breadcrumb: "Planes" },
  },
  {
    path: "/routes",
    name: "Rutas",
    component: Routes,
    meta: { breadcrumb: "Rutas" },
  },
  {
    path: "/live",
    name: "Flota",
    component: PlanLive,
    meta: { breadcrumb: "Vehículos en ruta" },
  },
  {
    path: "/live/analytics",
    name: "Analíticas",
    component: LiveAnalytics,
    meta: { breadcrumb: "Analíticas" },
  },
  {
    path: "/plan/:plan_id",
    name: "Plan Kanban",
    component: PlanKanban,
    meta: { breadcrumb: "Detalle" },
  },
  {
    path: "/config",
    name: "Configuracion",
    meta: { breadcrumb: "Configuración" },
  },
  {
    path: "/vehicles",
    name: "Vehículos",
    component: Vehicles,
    meta: { breadcrumb: "Vehículos" },
  },
  {
    path: "/stops",
    name: "Paradas",
    component: Stops,
    meta: { breadcrumb: "Paradas" },
  },
  {
    path: "/bultos",
    name: "Bultos",
    component: Bultos,
    meta: { breadcrumb: "Bultos" },
  },
  {
    path: "/evidence",
    name: "Evidencias",
    component: Evidence,
    meta: { breadcrumb: "Evidencias" },
  },
  {
    path: "/decas",
    name: "DeCAs",
    component: Decas,
    meta: { breadcrumb: "DeCAs" },
  },
  {
    path: "/zones",
    name: "Zonas",
    component: Zones,
    meta: { breadcrumb: "Zonas" },
  },
  {
    path: "/warehouses",
    name: "Puntos Habituales",
    component: Warehouses,
    meta: { breadcrumb: "Puntos habituales" },
  },
  {
    path: "/authentication/signin",
    name: "Login",
    component: SigninIllustration,
  },
  {
    path: "/recover_password",
    name: "Reset Password",
    component: ResetIllustration,
  },
  {
    path: "/recover/request-sended",
    name: "Request Change Password",
    component: ChangePasswordSended,
  },
  {
    path: "/restore_login",
    name: "Restore Login",
    component: RestorePassword,
  },
  //TTMM routes
    {
    path: "/ttmm",
    name: "TTMM",
    meta: { breadcrumb: "TTMM" },
  },
  {
    path: "/ttmm/events",
    name: "Eventos",
    component: Events,
    meta: { breadcrumb: "Eventos" },
  },
  {
    path: "/ttmm/users",
    name: "Usuarios Vehículos",
    component: UsersVehicle,
    meta: { breadcrumb: "Mensajeros" },
  },
  //Account routes
  {
    path: "/account",
    name: "Cuenta",
    meta: { breadcrumb: "Cuenta" },
  },
  {
    path: "/account/profile",
    name: "Configuración",
    component: Profile,
    meta: { breadcrumb: "Configuración" },
  },
  {
    path: "/account/users",
    name: "Usuarios",
    component: UsersPortal,
    meta: { breadcrumb: "Usuarios" },
  },
  {
    path: "/account/security",
    name: "Seguridad",
    component: SecurityKey,
  },
  {
    path: "/account/api",
    name: "Integración",
    component: Developer,
  },
  {
    path: "/account/api/docu",
    name: "Api Documentación",
    component: DocuInfo,
    meta: {breadcrumb: "Documentación"}
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/dashboard-default",
  },

];
